var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tips"},[_vm._v("\n    暂无权限，请联系系统管理员分配权限，或\n    "),_c('a',{attrs:{"href":((_vm.config.API_BASE) + "/map")}},[_vm._v("选择其他项目")])])])}
var staticRenderFns = []

export { render, staticRenderFns }